import { render } from "./CheckAccessibility.vue?vue&type=template&id=00fefa52&scoped=true"
import script from "./CheckAccessibility.vue?vue&type=script&lang=js"
export * from "./CheckAccessibility.vue?vue&type=script&lang=js"

import "./CheckAccessibility.vue?vue&type=style&index=0&id=00fefa52&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-00fefa52"

export default script